<template>


    <div >
        <h4 class="mt-2"> Finance Reports</h4>

         <div class="scroll-y pt-2">
            <h4 class="mt-3"> Settlement Information</h4>
            <div class="mt-2">
                <amf-datepicker label="Settlement Date"  v-model="settlementDate" />
            </div>

            <table class="table table-bordered table-sm mt-3 table-settlements">
                <thead>
                    <th>AMFCode</th>
                    <th>Employer Name</th>
                    <th>Employer Total</th>
                </thead>
                <tbody>
                    <tr  v-for="settlement in settlements">
                        <td>{{settlement.amfCode}}</td>
                        <td>{{settlement.name}}</td>
                        <td>{{$formatters.money(settlement.totalSalesTransaction)}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td></td>
                        <td></td>
                        <td class="total">Total: {{$formatters.money(grandTotal)}}</td>
                    </tr>
                </tfoot>
            </table>
         </div>
    </div>
</template>

<script>
import { date } from '../framework/utils/validation';
import { romeApi } from '../framework/utils/rome-api';
const properties = "dateOfSettlement";

export default {
     data() {
        return {
            settlementDate: null,
            settlements: [],
            grandTotal: Number = 0,
            amfOptions: { noTracking: true, },
        }
    },
    created() {
        this.load();
    },
    watch: {
        settlementDate: {
            handler: function(val, oldVal){
                this.load(val);
            }
        },
    },
    methods:{
        async load(date) {
            var url = `finance/settlement-information`;

            if(date !== undefined){
                let formattedDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
                url += `/?date=` + formattedDate;
            }

            let settlements = await romeApi.get(url);
            this.settlements = settlements;
            this.grandTotal = this.settlements.reduce((total, s)=> total + s.totalSalesTransaction, 0);

            if(date === undefined && settlements.length > 0)
            {
                this.settlementDate = settlements[0].transactionDate;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    .total {
        font-weight: bold;
        text-align: right;
    }

    .table-settlements {
        td,th {
            text-align: center;
            padding: 6px;
        }
        th {
            background-color: #e5e5e5;
            border: 0px;
            border-top: 1px solid #eaeaea;
            border-bottom: 1px solid #eaeaea;
        }
    }
</style>



// WEBPACK FOOTER //
// src/finance/SettlementInformation.vue